/**
 * Central property-identifier validation shared by the guest primitives
 * (#1138).
 *
 * Central's property identifier is its `uuid` field. It is NOT an RFC UUID:
 * the only writer (central PropertyObserver) sets `'PROP' . crc32(...)`, so
 * every live property today is PROP-shaped (e.g. "PROP4155250208"). The RFC
 * 4122 alternative is accepted for forward compatibility should Central ever
 * migrate the field to real UUIDs.
 *
 * Legacy WP/ckit code wrote NUMERIC WordPress post ids into the same guest
 * storage key (`homelocal_favorites`). A bare numeric is therefore never a
 * Central identifier: every guest primitive that SENDS an id to Central or
 * renders it as a resolved property must first pass this check; anything else
 * is an opaque foreign token to preserve, never to interpret.
 */
export const CENTRAL_PROPERTY_UUID_RE =
  // PROP-shaped (case-sensitive, as written by Central) OR RFC 4122
  // (case-insensitive via explicit hex ranges — the PROP prefix must NOT be).
  /^(?:PROP[0-9]{1,10}|[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/

export function isCentralPropertyUuid(token: string): boolean {
  return CENTRAL_PROPERTY_UUID_RE.test(token)
}
